// Constants for different requests for current reducer
export default {
  shiftLog: 'SHIFT_LOG',
};
